var map = {
	"./Logo-1.svg": "219c",
	"./Logo-10.svg": "77e6",
	"./Logo-11.svg": "169f",
	"./Logo-12.svg": "a391",
	"./Logo-13.svg": "6a95",
	"./Logo-14.svg": "d4430",
	"./Logo-15.svg": "c1dff",
	"./Logo-16.svg": "82e8",
	"./Logo-17.svg": "9f53",
	"./Logo-18.svg": "5f61",
	"./Logo-19.svg": "af69",
	"./Logo-2.svg": "eaf6",
	"./Logo-20.svg": "a34d",
	"./Logo-3.svg": "0df69",
	"./Logo-4.svg": "f26d",
	"./Logo-5.svg": "5dc9",
	"./Logo-6.svg": "dbaf",
	"./Logo-7.svg": "1423",
	"./Logo-8.svg": "261a",
	"./Logo-9.svg": "8310"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4380";